export default __webpack_public_path__ + "static/media/nav-email.f79bb888.svg";